export default __webpack_public_path__ + "static/media/video14.9d3c0387.webp";